import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1bbd8472")

_pushScopeId("data-v-1bbd8472")
const _hoisted_1 = { class: "seat-head" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("去选座")
const _hoisted_3 = { class: "seat" }
const _hoisted_4 = { id: "seats" }
const _hoisted_5 = { class: "info" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "head" }, "需要选座的乘客", -1)
const _hoisted_7 = { class: "btn" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("确认")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_form = _resolveComponent("el-form")
  const _component_select_seat = _resolveComponent("select-seat")
  const _component_el_card = _resolveComponent("el-card")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        model: _ctx.formData,
        rules: _ctx.rules,
        ref: "form",
        "label-width": "85px",
        "label-position": "left",
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
      }, {
        default: _withId(() => [
          _createVNode(_component_el_row, null, {
            default: _withId(() => [
              _createVNode(_component_el_form_item, {
                label: "订单号",
                prop: "id"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.id,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.id = $event)),
                    placeholder: "请输入订单号"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                class: "submit",
                onClick: _ctx.onSubmit
              }, {
                default: _withId(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_select_seat, {
          selected: _ctx.seats,
          "onUpdate:selected": _cache[3] || (_cache[3] = ($event: any) => (_ctx.seats = $event))
        }, null, 8, ["selected"])
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode("div", null, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.customers, (customer, index) => {
          return (_openBlock(), _createBlock(_component_el_card, { key: index }, {
            default: _withId(() => [
              _createVNode("div", null, _toDisplayString('乘客姓名：' + customer.name), 1),
              _createVNode("div", null, _toDisplayString('身份证号：' + customer.id), 1),
              _createVNode("div", null, _toDisplayString('座位号：' + customer.seat), 1)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_el_button, { onClick: _ctx.confirm }, {
          default: _withId(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ], 64))
})